<template>
  <!-- 选择支付方式弹窗 -->
  <custom-dialog
    v-if="dialogVisible"
    width="400px"
    top="23vh"
    :visible="dialogVisible"
    :close-on-press-escape="false"
    :show-close="false"
    title="收费"
    @close="closeHandle"
    @save="confirmHandle"
  >
    <div class="content" v-loading="loading" element-loading-text="支付中，请稍后..." slot="content">
      <div class="content-price">
        <span class="price-icon">¥</span>
        <span>{{ rechargeOrderInfo.prePayAmount || 0 }}</span>
      </div>
      <div class="pay">
        <div
          class="pay-item"
          :class="{active: activePayType == item.code}"
          v-for="item in payTypeList"
          :key="item.code"
          @click="activePayType = item.code"
        >
          <img :src="item.icon" class="img-icon">
          <div class="item-label">{{ item.name }}</div>
        </div>
      </div>
      <div class="footer">
        <i class="el-icon-info"></i>
        <span class="tips">不支持组合支付</span>
        <custom-button size="small" type="info" :loading="cancelBtnLoading" :disabled="payBtnLoading" @click="closeHandle">取消</custom-button>
        <custom-button size="small" type="primary" :loading="payBtnLoading" :disabled="cancelBtnLoading" @click="confirmHandle">收费</custom-button>
      </div>
    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>
 
<script>
  import req from '@/utils/request'
  export default {
    data() {
      return {
        payTypeList: [],
        activePayType: '',
        cancelBtnLoading: false
      }
    },
    methods: {
      // 获取支付方式
      async getPayTypeList() {
        const { code, data } = await req.post('/pay/getPayWay')
        if (code === 200) {
          this.payTypeList = (data || []).filter(item => [2, 3].includes(item.code))  // 2:现金 3:好码齐
        }
      },
      confirmHandle() {
        if (!this.activePayType) return this.$message.error('请选择支付方式')
        this.$emit('confirm', this.activePayType)
      },
      
      async closeHandle() {
        const params = {
          rechargePayRecordId: this.rechargeOrderInfo.id
        }
        this.cancelBtnLoading = true
        const { code } = await req.post('/member/wallet/recharge/cancel', params)
        this.cancelBtnLoading = false
        if (code === 200) {
          this.dialogVisible = false
        }
      }
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      rechargeOrderInfo: {
        type: Object,
        default: () => ({})
      },
      loading: {
        type: Boolean,
        default: false
      },
      payBtnLoading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    components: {
      CustomDialog: () => import('@/components/customDialog/CustomDialog')
    },
    watch: {
      value(newVal) {
        if (newVal) {
          this.activePayType = ''
          this.getPayTypeList()
        }
      }
    }
  }
 
</script>

<style scoped lang='less'>
.content {
  .content-price {
    margin-top: 16px;
    color: #FE8F1F;
    font-size: 24px;
    font-weight: bold;
    text-align: center;

    .price-icon {
      margin-right: 4px;
      font-size: 16px;
    }
  }

  .pay {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    margin-top: 24px;

    .pay-item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #D3D3D5;
      color: #1F2329;
      font-size: 14px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        border: 1px solid #1890FF;
      }

      .img-icon {
        width: 16px;
        height: 16px;
        flex-grow: 0;
        flex-shrink: 0;
        margin-right: 6px;
      }

      .item-label {
        width: 42px;
        text-align: justify;
        text-align-last: justify;
      }
    }

    .active {
      border: 1px solid #1890FF;
      background: #E8F4FF;
      color: #1890FF;
    }
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 40px;

  .el-icon-info {
    color: #1890FF;
    font-size: 14px;
  }

  .tips {
    margin: 0 12px 0 2px;
    font-size: 12px;
    color: #667182;
  }
}

/deep/.el-loading-mask {
  top: -60px;
}
/deep/.el-loading-text {
  margin-top: 20px;
}
</style>